export const adminSideLinks = [
  { to: '/admin', label: 'Dashboard' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/jobs', label: 'Jobs' },
  { to: '/admin/payments', label: 'Payments' },
  { to: '/admin/verifications', label: 'Verifications' },
  { to: '/admin/analytics', label: 'Analytics' },
  { to: '/admin/logs', label: 'Logs' },
  { to: '/admin/reports', label: 'Reports' },
  { to: '/admin/profile', label: 'Profile' },
  { to: '/admin/settings', label: 'Settings' },
];
